import { render, staticRenderFns } from "./customerDetails.vue?vue&type=template&id=514b24d0&scoped=true"
import script from "./customerDetails.vue?vue&type=script&lang=js"
export * from "./customerDetails.vue?vue&type=script&lang=js"
import style0 from "./customerDetails.vue?vue&type=style&index=0&id=514b24d0&prod&scoped=true&lang=scss"
import style1 from "./customerDetails.vue?vue&type=style&index=1&id=514b24d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514b24d0",
  null
  
)

export default component.exports